import SEO from "components/seo";
import { Link } from "gatsby";
import OptimizedImage from "hooks/OptimizedImage";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Form from "../Form";
import Social from "../Social";
import TranslatorHubHeader from "../TranslatorHubHeader/TranslatorHubHeader";
import loadable from "@loadable/component";

const Index = (props) => {
  const [scrolled, setScrolled] = useState(false);
  const listenToScroll = () => {
    setScrolled(true);
  };
  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    return () => window.removeEventListener("scroll", listenToScroll);
  }, []);

  const FormMobile = loadable(() => import("../FormMobile"));
  const HubComments = loadable(() => import("./HubComments"));
  const Footer = loadable(() => import("components/layout/footer"));
  const [hasLoadedFromScript, setHasLoadedFromScript] = useState(false);
  const {
    pageContext: {
      data: { data },
    },
  } = props;
  const project_id = data.seo_project_id;
  const scriptAlreadyExists = () =>
    document.querySelector("script#alert-script") !== null;

  const appendDynamicFormSubmitScript = () => {
    var inlineScript = document.createTextNode(
      "function handleForm(){function getCookie(cookieName){let name = cookieName + '=';let ca = document.cookie.split(';');for (let i = 0; i < ca.length; i++) {let c = ca[i];while (c.charAt(0) === ' ') {c = c.substring(1);};if (c.indexOf(name) === 0) {return c.substring(name.length, c.length);};};return 'not set';};var email=document.getElementById('midemail').value;const response=fetch('https://admin.tomedes.com/api/v1/submit-subscribe',{method:'POST',body:JSON.stringify({'email':email, pageLink: location.href, source: getCookie('utm_source'), utm_campaign: getCookie('utm_campaign'), utm_agid: getCookie('utm_agid'), utm_term: getCookie('utm_term'), creative: getCookie('creative'), device: getCookie('device'), placement: getCookie('placement'), utm_medium: getCookie('utm_medium'),}),headers:{'Content-Type':'application/json'}}).then(data=>{return data.json();}).then(resp=>{if(resp.success===1){document.getElementById('midemail').value='';document.getElementById('orangeForm').style.display='none';document.getElementById('orangeThankyou').style.display='block';document.getElementById('closeThankyou').addEventListener('click',function(){document.getElementById('orangeThankyou').style.display='none';document.getElementById('orangeForm').style.display='block';})}else{}});}"
    );
    const script = document.createElement("script");
    script.id = "alert-script";
    script.async = true;
    script.appendChild(inlineScript);
    setHasLoadedFromScript(true);
    document.body.append(script);
  };

  useEffect(() => {
    if (!scriptAlreadyExists()) {
      appendDynamicFormSubmitScript();
    }
  }, []);

  useEffect(() => {
    if (hasLoadedFromScript === true) {
      let ul = document.getElementsByTagName("p")[10];
      const form =
        "<div id='orangeForm' class='orangeForm classImp w-full bg-orangeFormBgMobile sm:bg-orangeFormBgDektop bg-cover bg-center py-11 px-6 sm:px-11  text-white mt-10 mb-8'><h2 class='xs:font-secondary text-white text-17 sm:text-[33px] font-bold text-center sm:text-left'><span class='block'>Broaden Your Horizons</span><span class='block'>With International Strategy</span><span class='block'>and Local Knowledge</span></h2><p class='xs:font-opensans font-semibold text-14 sm:text-[20px] text-left my-5'>Subscribe to Our Business Newsletter!</p><form  onsubmit='handleForm();return false' class='flex flex-col sm:flex-row gap-3'><input type='text' name='midemail' id='midemail' placeholder='Please enter a valid business email' class='text-black xs:font-opensans font-light px-2 py-2 w-full md:w-8/12 2xl:w-5/12' /><input type='hidden' id='zc_gad' name='zc_gad' value='' /><button type='submit' class='bg-[#001546] hover:bg-[#0032A7] xs:font-opensans font-semibold text-14 text-[#E6E6E6] py-2 px-8 transition-colors duration-300'>Submit</button></form></div><div id='orangeThankyou' class=' hidden w-full thankyou classImp2 bg-orangeFormBgMobile sm:bg-orangeFormBgDektop bg-cover bg-center py-20 sm:py-24 px-8 sm:px-11  text-white mt-10 mb-8'><h2 class='xs:font-secondary text-[32px] sm:text-46 font-bold mb-5 text-center sm:text-left'>Thank you!</h2><p class='xs:font-opensans font-semibold text-17 sm:text-[20px] text-center sm:text-left my-5'>Please check your inbox for a confirmation email.</p><button id='closeThankyou' class='bg-[#001546] hover:bg-[#0032A7] xs:font-opensans font-semibold text-14 text-[#E6E6E6] py-2 px-8 transition-colors duration-300 sm:hidden w-full'>Close</button></div>";
      ul.innerHTML += form;
    }
  }, [hasLoadedFromScript]);

  return (
    <React.Fragment>
      <TranslatorHubHeader title="Translator's Blog" />
      <SEO
        title={data.seo_project_title || data.title_x || data.seo_h1}
        description={data.seo_project_meta_desc}
        keywords={data.seo_project_meta_keywords}
        slug={data.slug}
      />
      <div className="w-11/12 sm:w-10/12 md:w-11/12 md:px-3 md:max-w-2xl lg:max-w-none xl:max-w-7xl mx-auto lg:w-full xl:pl-[150px]">
        <div className="flex flex-col lg:flex-row lg:gap-20 max-w-370 sm:max-w-full mx-auto sm:mx-0">
          <div className="col-span-2">
            <h1 className="text-[28px] pb-6 text-blackNew-600 font-semibold mt-10">
              {data.seo_h1}
            </h1>
            <div className="my-6">
              <i className="text-blackNew-700">
                {moment(data.seo_project_create_date).format("MMMM D, YYYY")}
              </i>
            </div>
            <OptimizedImage
              src={data.cover_image}
              alt={data.seo_h1}
              lazyload={false}
              className="w-[343px] sm:w-full xl:w-full object-cover h-[216px] sm:h-auto lg:h-[370px] max-h-80 mb-6"
            />
            <div
              className="mb-4 translator_hub_details [p:nth-child(3n+1)]"
              dangerouslySetInnerHTML={{ __html: data.seo_project_content }}
            />
            <div className="hidden sm:block lg:hidden py-3">
              <Form marginX="0" />
            </div>
            {scrolled ? (
              <>
                <div className="sm:hidden">
                  <FormMobile marginX="0" />
                </div>
                <HubComments data={data} project_id={project_id} />
              </>
            ) : null}
          </div>
          <div className="w-full ml-0 mt-10 md:mt-0 px-4 lg:pl-0">
            <div>
              <h5 className="font-bold text-newGray text-new mt-4 lg:mt-10">
                CATEGORIES
              </h5>
              <ul className="text-newGray">
                {props.pageContext.uniqueCategories.map((link, index) => (
                  <li
                    className="text-new py-2 hover:text-newLightBlue cursor-pointer"
                    key={index}
                  >
                    <Link to={`/translator-hub.php/category/${link}`}>
                      {link}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="line border-b border-gray mt-12"></div>
            <div className="hidden lg:block">
              <Form marginX="0" />
            </div>
            <Social />
          </div>
        </div>
      </div>
      {scrolled ? <Footer /> : null}
    </React.Fragment>
  );
};
export default Index;
